import { SigningService } from '@fastre/core/schemas/esign'
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Modal,
    ModalClose,
    ModalDialog,
    Typography,
} from '@mui/joy'
import { useApi } from 'api'
import { useShowSnack } from 'components/snackbar'
import { prop } from 'ramda'
import { useState } from 'react'
import { useListingContext } from '../listingProvider'

interface Props {
    open: boolean
    onClose: (url?: string) => void
    formType: string
    signingService: SigningService
    title?: string
    message?: string
}

const UploadFormModal = ({ 
    open, 
    onClose, 
    formType, 
    signingService,
    title = "Upload Form",
    message = "Upload functionality for documents is not yet implemented."
}: Props) => {
    const { listing } = useListingContext()
    const showSnack = useShowSnack()
    const api = useApi()

    const [loading, setLoading] = useState(false)

    const handleUpload = async () => {
        setLoading(true)
        try {
            // This would typically handle file upload
            // For now, just close the modal
            showSnack('Upload functionality not implemented yet', 'warning')
            onClose()
        } catch (error) {
            console.error('Error uploading form:', error)
            showSnack('Error uploading form', 'danger')
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal open={open} onClose={() => onClose()}>
            <ModalDialog>
                <ModalClose />
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <Typography>
                        {message}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => onClose()}>
                        Cancel
                    </Button>
                    <Button loading={loading} onClick={handleUpload}>
                        Upload
                    </Button>
                </DialogActions>
            </ModalDialog>
        </Modal>
    )
}

export default UploadFormModal
